import styled from "styled-components";


export const CollectionHubContainer = styled.div`
    position: absolute;
    transform: translate(-50%, -100%);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
        width: 106px;
        height: 89px;
    }
`;

export const CollectionHubMarker = styled.div`
    position: relative;
    white-space: nowrap;
    padding: 2px 6px;
    justify-content: center;
    align-items: center;
    border-radius: 500px;
    color: #fff;
    
    border: ${(props) => props.isSelected ? '1.5px dashed #0ca33f' : 'none'};
    background: ${(props) => props.isSelected ? '#15e254' : '#303742'};

    font-weight: 600;
    font-style: normal;
    font-size: 10px;
    line-height: 145%;
    letter-spacing: -1%;
    vertical-align: middle;
    transition: background 0.3s ease;

    ::after {
        content: "";
        position: absolute;
        left: 50%;
        top: 100%;
        transform: translate(-50%, 0);
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        
        border-top: 7.3px solid ${props => props.isSelected ? '#15e254' : '#303742'};
        transition: border-top 0.3s ease;
    }
`;